import React from 'react';
import PropTypes from 'prop-types';

import ModerationContext from './moderationContext';

export default function ModerationContextProvider({ children }) {
    const [moderationContext, _setModerationContext] = React.useState({ removedAttendeesQuery: {} });

    const setModerationContext = React.useCallback((ctx = {}) => {
        _setModerationContext(moderationContext => {
            return { ...moderationContext, ...ctx };
        });
    }, []);

    const removeFromModerationContext = React.useCallback(name => {
        _setModerationContext(moderationContext => {
            let newContext = { ...moderationContext };
            delete newContext[name];
            return newContext;
        });
    }, []);

    return (
        <ModerationContext.Provider
            value={{
                moderationContext,
                setModerationContext,
                removeFromModerationContext
            }}
        >
            {children}
        </ModerationContext.Provider>
    );
}

ModerationContextProvider.propTypes = {
    children: PropTypes.node
};
